import { Route } from "react-router-dom";

import Productions from "../pages/Productions";
import ProductionsCalendar from "../pages/ProductionsCalendar";
import ProductionsTable from "../pages/ProductionsTable";

export const productions = (
	<Route path="productions" element={<Productions />} handle={{ crumb: ({ t }) => t("productions", "Productions") }}>
		<Route index element={<ProductionsTable />} />

		<Route path="calendar" element={<ProductionsCalendar />} />
	</Route>
);
